/**
 * Non-PII consumer context for GTM payloads (see ConsumerHeader, BlogPage, etc.).
 */
export interface ConsumerGtmContext {
  user_type: "consumer";
  is_authenticated: boolean;
}

export const getConsumerGtmContext = (
  isAuthenticated: boolean
): ConsumerGtmContext => ({
  user_type: "consumer",
  is_authenticated: isAuthenticated
});
